export const TRANSLATION_KEYS = {
    SubjectLabel: "ticketDetailsPage.detailsForm.subjectLabel",
    DescriptionLabel: "ticketDetailsPage.detailsForm.descriptionLabel",
    AgentLabel: "ticketDetailsPage.detailsForm.agentLabel"
};